export const fiatCurrencies = ['EUR', 'USD', 'BRL', 'MXN'] as const

// Source: https://apidocs.bridge.xyz/get-started/introduction/what-we-support/payment-routes
// Triple Checked: 2025-11-22
export const stablecoins = [
  { symbol: 'USDC', networks: ['Ethereum', 'Solana', 'Polygon', 'Arbitrum', 'Optimism', 'Base', 'Avalanche', 'Stellar'] as const },
  { symbol: 'USDT', networks: ['Ethereum', 'Tron'] as const }, // Note: Solana USDT not listed in Bridge fiat routes
  { symbol: 'USDB', networks: ['Base', 'Solana'] as const },
  { symbol: 'EURC', networks: ['Solana', 'Base'] as const },
  { symbol: 'PYUSD', networks: ['Ethereum', 'Solana'] as const },
  { symbol: 'USDP', networks: ['Solana'] as const },
  { symbol: 'DAI', networks: ['Ethereum'] as const },
  { symbol: 'ETH', networks: ['Ethereum'] as const }, // Native asset
  { symbol: 'BTC', networks: ['Bitcoin'] as const },  // Native asset
] as const

export const supportedPairs = [
  // USDC
  { base: 'USDC', quote: 'EUR' }, { base: 'USDC', quote: 'USD' }, { base: 'USDC', quote: 'BRL' }, { base: 'USDC', quote: 'MXN' },
  // USDT
  { base: 'USDT', quote: 'EUR' }, { base: 'USDT', quote: 'USD' }, { base: 'USDT', quote: 'BRL' }, { base: 'USDT', quote: 'MXN' },
  // USDB (Bridge Native)
  { base: 'USDB', quote: 'EUR' }, { base: 'USDB', quote: 'USD' }, { base: 'USDB', quote: 'BRL' }, { base: 'USDB', quote: 'MXN' },
  // EURC
  { base: 'EURC', quote: 'EUR' }, { base: 'EURC', quote: 'USD' },
  // PYUSD
  { base: 'PYUSD', quote: 'USD' }, { base: 'PYUSD', quote: 'EUR' },
  // USDP
  { base: 'USDP', quote: 'USD' },
  // Crypto Native
  { base: 'ETH', quote: 'USD' }, { base: 'ETH', quote: 'EUR' },
  { base: 'BTC', quote: 'USD' }, { base: 'BTC', quote: 'EUR' },
  { base: 'DAI', quote: 'USD' },
] as const

export const fiatRails = [
  { currency: 'EUR', rails: ['SEPA'] as const }, // Bridge Docs: SEPA (EUR)
  { currency: 'USD', rails: ['ACH', 'Wire'] as const }, // Bridge Docs: ACH (USD), Wire (USD)
  { currency: 'BRL', rails: ['Pix'] as const }, // Bridge Docs: (Beta) Pix (BRL)
  { currency: 'MXN', rails: ['SPEI'] as const }, // Bridge Docs: SPEI (MXN)
] as const

export const coverageFacts = {
  fiatCurrencies,
  stablecoins,
  supportedPairs,
  fiatRails,
} as const
